import React from 'react'

import styles from './card.module.css'
import exportIcon from '../../assets/images/exportIcon.svg'

export const Card = props => {
  return <div className={styles.parentContainer}>
    <div className={styles.cardHeader}>
      <label>{new Date(props.date).toDateString()}</label>
      <img onClick={() => props.export(props.date)} src={exportIcon} alt="Export" />
    </div>
    <div className={styles.container}>
      {Object.keys(props).filter(prop => prop !== 'date' && prop !== 'export').map(prop => {
        var propertyName
        switch (prop) {
          case 'totalRake':
            propertyName = 'Total Rake'
            break;
          case 'totalCredits':
            propertyName = 'Credit In'
            break
          case 'totalUncredits':
            propertyName = 'Credit Out'
            break
          case 'totalPlayers':
            propertyName = 'Total Players'
            break
          case 'totalHands':
            propertyName = 'Total Hands'
            break
          default:
            break;
        }
        return <div className={[styles[prop], styles.singleProp].join(' ')}>
          <label>{propertyName}</label>
          <label>{props[prop]}</label>
        </div>
      })}
    </div>
  </div>
}